// アラートメッセージ
const ALERT_MESSAGE = '編集中の設定は破棄されます。よろしいですか？';

/**
 * 編集し、未保存状態を通知するmixin
 */
export default {
    data() {
        return {
            // 設定が変更されたか否かのフラグ
            edited: false,
            // 変更一つ前のデータ
            old_data: {},
            // 文字数オーバーメッセージ表示フラグ
            over_text_length: false,
            // 文字数オーバーになった際のメッセージ
            over_text_length_message: ''
        };
    },
    methods: {
        // 初期化(createdで呼び出す)
        iniEditedFlag: function (key, judgment = () => (true)) {
            // 設定未保存時のページ遷移アラート
            window.addEventListener('beforeunload', (e) => {
                if (this.edited && judgment()) {
                    e.preventDefault();
                    e.returnValue = '';
                }
            }, false);

            // 編集データが更新されたらeditedフラグをtrue(old_dataが空の場合は初回な為除く)
            this.$watch(
                key,
                function (value) {
                    if (Object.keys(this.old_data).length > 0) {
                        this.edited = true;
                    }
                    this.old_data = value;
                },
                {
                    deep: true
                }
            );
        },
        // 編集中フラグを更新
        updateEdited: function (bool) {
            this.edited = bool;
        },
        // 設定破棄アラートを表示
        destConfirm: async function () {
            if (!this.edited) {
                return true;
            }
            if (this.edited && await swalConfirm(ALERT_MESSAGE)) {
                this.updateEdited(false);
                return true;
            }
            return false;
        },
        // 文字数オーバーフラグを更新する
        updateTextOverFlag: function (flag, message) {
            this.over_text_length = flag;
            this.over_text_length_message = message;
        }
    }
};
